import css from "PFApp/profiles/edit/profile_edit_panel.module.scss";
import { Button } from "PFComponents/button";
import { Card } from "PFComponents/card";
import CardHeader from "PFComponents/card/card_header";
import { Component, CSSProperties, ReactNode } from "react";

type ProfileEditPanelProps = {
  title?: string;
  headingButtonLabel?: string;
  headingButtonDisabled?: boolean;
  headingButtonQaId?: string;
  handleHeadingButtonClick?: () => void;
  children?: ReactNode;
  style?: CSSProperties;
};

export default class ProfileEditPanel extends Component<ProfileEditPanelProps> {
  render() {
    const {
      title,
      children,
      headingButtonLabel,
      headingButtonDisabled,
      handleHeadingButtonClick,
      headingButtonQaId
    } = this.props;

    return (
      <Card>
        <CardHeader
          titleQaId="profile-edit-section-title"
          title={title}
          style={{ padding: 0, marginBottom: 16 }}
          action={
            headingButtonLabel && (
              <Button
                disabled={headingButtonDisabled}
                onClick={handleHeadingButtonClick}
                qaId={headingButtonQaId}
                small
              >
                {headingButtonLabel}
              </Button>
            )
          }
        />
        <div className={css.body}>{children}</div>
      </Card>
    );
  }
}
